import React, { useEffect, useState } from 'react';
import { getAge, formatDate, downloadPDF } from '../ContratFunctions.js';
import TarifGrid from '../TarifGrid.js';
import TarifOption from '../TarifOption.js';
import { PrivateAxios } from '../../../request/axios.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaFileContract, FaUser, FaMoneyBillWave } from 'react-icons/fa';
import Swal from 'sweetalert2';

const Step3 = ({ formData, beneficiaire, handleStepChange }) => {
    const [totalHT, setTotalHT] = useState(0);
    const [totalTTC, setTotalTTC] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [localOptionFH, setLocalOptionFH] = useState(false)
    const [days, setDays] = useState(0);
    const [nbAs, setNbAs] = useState(0);
    const [nbP70s, setNbP70s] = useState(0);
    const [nbP12s, setNbP12s] = useState(0);
    const [nbM12s, setNbM12s] = useState(0);
    const tarifGrid = TarifGrid;
    const optionPrice = TarifOption;
    const version = 1;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const calculateDays = (dateDepart, dateRetour) => {
        const startDate = new Date(dateDepart);
        const endDate = new Date(dateRetour);
        return (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
    };

    useEffect(() => {
        const customRound = (value) => {
            const decimalPart = value % 1;
            if (decimalPart < 0.5) {
                return Math.floor(value);
            } else {
                return Math.ceil(value);
            }
        };
        const calculateTarif = () => {
            const dateRoute = formData.dateRetour
            setLocalOptionFH(formData.optionForfait)
            setDays(calculateDays(formData.dateDepart, dateRoute));

            let baseTarif = tarifGrid.find(t => days >= t.minDays && days <= t.maxDays)?.price || 0;
            if (baseTarif === 0) {
                setTotalHT("Aucun tarif disponible pour cette période.");
                return;
            }

            let PrimeNet = 0;
            let MtForfaitNet = 0;

            // Compter les catégories d'âges
            const NbA = beneficiaire.filter(user => getAge(user.dateNaissance, dateRoute, dateRoute) >= 18 && getAge(user.dateNaissance, dateRoute) < 70).length;
            setNbAs(NbA);            
            const NbP70 = beneficiaire.filter(user => getAge(user.dateNaissance, dateRoute) >= 70).length;
            setNbP70s(NbP70);
            const NbP12 = beneficiaire.filter(user => getAge(user.dateNaissance, dateRoute) >= 12 && getAge(user.dateNaissance, dateRoute) < 18).length;
            setNbP12s(NbP12);
            const NbM12 = beneficiaire.filter(user => getAge(user.dateNaissance, dateRoute) < 12).length;
            setNbM12s(NbM12);

            if (localOptionFH && NbA === 0 && NbP12 === 0 && NbM12 === 0 && NbP70 > 0){
                Swal.fire({
                    title: "Attention, option forfait hospitalier !",
                    text: "Vous avez sélectionné le forfait hospitalier alors qu'aucune personne n'est éligible. L'option sera automatiquement retirée.",
                    icon: "warning"
                });
                setLocalOptionFH(false)    
            }

            if (formData.optionFamille) {
                if (NbA !== 0 || NbP12 !== 0 || NbP70 !== 0) {
                    if (NbM12 >= 2) {
                        PrimeNet = (baseTarif * (NbA + NbP70)) + (baseTarif * NbP12) + ((baseTarif / 2) * 2);
                        MtForfaitNet = (optionPrice * NbA) + (optionPrice * NbP12) + ((optionPrice / 2) * 2);
                    } else {
                        PrimeNet = (baseTarif * (NbA + NbP70)) + (baseTarif * NbP12) + ((baseTarif / 2) * NbM12);
                        MtForfaitNet = (optionPrice * NbA) + (optionPrice * NbP12) + ((optionPrice / 2) * NbM12);
                    }
                } else {
                    if (NbM12 >= 5) {
                        PrimeNet = ((baseTarif / 2) * 5);
                        MtForfaitNet = ((optionPrice / 2) * 5);
                    } else {
                        PrimeNet = ((baseTarif / 2) * NbM12);
                        MtForfaitNet = ((optionPrice / 2) * NbM12);
                    }
                }

                PrimeNet = PrimeNet - (PrimeNet * (formData.remise / 100))
                PrimeNet = PrimeNet - (PrimeNet * (formData.remisePartenaire / 100))
                PrimeNet = PrimeNet - (PrimeNet * (formData.remiseExceptionnelle / 100))
                MtForfaitNet = MtForfaitNet - (MtForfaitNet * (formData.remise / 100))
                MtForfaitNet = MtForfaitNet - (MtForfaitNet * (formData.remisePartenaire / 100))
                MtForfaitNet = MtForfaitNet - (MtForfaitNet * (formData.remiseExceptionnelle / 100))

            } else {

                PrimeNet = (baseTarif * (NbA + NbP70)) + (baseTarif * NbP12) + (baseTarif * NbM12);
                MtForfaitNet = (optionPrice * NbA) + (optionPrice * NbP12) + (optionPrice * NbM12);

                const totalPeople = NbA + NbP12 + NbP70 + NbM12;
                if (totalPeople >= 50) setDiscount(0.5);
                else if (totalPeople >= 40) setDiscount(0.4);
                else if (totalPeople >= 30) setDiscount(0.3);
                else if (totalPeople >= 20) setDiscount(0.2);
                else if (totalPeople >= 10) setDiscount(0.1);

                PrimeNet = PrimeNet - (PrimeNet * discount);
            }


            let totalTarif = PrimeNet + (localOptionFH ? MtForfaitNet : 0);

            setTotalHT(customRound(totalTarif));
            setTotalTTC(customRound(totalTarif * 1.07));
        };

        calculateTarif();
    }, [formData, beneficiaire, optionPrice, tarifGrid, setDiscount, discount, days]);

    const handleValidateContrat = async () => {

        const result = await Swal.fire({
            title: 'Voulez-vous ajouter ce contrat ?',
            text: "Cette action est irréversible, une fois validé le contrat sera ajouté et considéré comme approuvé par le client.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, ajouter !',
            cancelButtonText: 'Annuler',
            showClass: {
                popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOutUp'
            }
        });

        if (result.isConfirmed) {
            setIsSubmitting(true);
            const payload = {
                souscripteur: {
                    genre: formData.genre,
                    nom: formData.nom,
                    ...(formData.nomEpouse && { nomEpouse: formData.nomEpouse }),
                    prenom: formData.prenom,
                    adresse: formData.adresse,
                    profession: formData.profession,
                    numCI: formData.numCI,
                    codePostal: formData.codePostal.toString(),
                    ville: formData.ville,
                    telephone: formData.telephone.toString(),
                    destination: formData.destination,
                    dateDepart: formData.dateDepart,
                    dateRetour: formData.dateRetour,
                    optionFamille: formData.optionFamille,
                    optionForfait: localOptionFH,
                },
                personnes: beneficiaire,
                contrat: {
                    nbJours: days,
                    tarif: {
                        totalHT: totalHT,
                        totalTTC: totalTTC,
                        ...(formData.remise && formData.remise > 0 && formData.remise <= 100 && { remise: formData.remise / 100 }),
                        ...(formData.remisePartenaire && formData.remisePartenaire > 0 && formData.remisePartenaire <= 10 && { remisePartenaire: formData.remisePartenaire / 100 }),
                        ...(formData.remiseExceptionnelle && formData.remiseExceptionnelle > 0 && formData.remiseExceptionnelle <= 20 && { remiseExceptionnelle: formData.remiseExceptionnelle / 100 }),
                        ...(discount && { remiseGroup: discount })
                    },
                    version: version
                }
            };

            try {
                const response = await PrivateAxios.post('/contrat/all', payload);
                const result2 = await Swal.fire({
                    title: 'Succès',
                    text: `Le contrat a été ajouté avec succès, cliquer sur 'OK' pour lancer téléchargementdu contrat. Vous devez faire signer ce contrat au client.`,
                    icon: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    }
                });
                await downloadPDF(response.data.contrat_id)
                navigate(0);

            } catch (err) {
                const message = err.response.data.message ? err.response.data.message : 'Internal server...'
                toast.error(`Erreur lors de la création du contrat : ${message}`);
                setIsSubmitting(false);
            }
        }
    };


    const getCategory = (age) => {
        if (age < 12) return "-12";
        if (age >= 12 && age < 18) return "12-17";
        if (age >= 18 && age < 70) return "18-69";
        if (age >= 70) return "70+";
    };

    return (
        <div className="p-6 rounded-lg shadow-md bg-gray-50">
            <h2 className="pb-2 mb-4 text-2xl font-bold text-gray-900 border-b-2 border-gray-300">Récapitulatif du Contrat</h2>

            {/* Informations Souscripteur */}
            <div className="p-6 mb-4">
                <div className="flex items-center mb-4">
                    <div className="p-3 mr-4 rounded-full bg-axa-blue-400">
                        <FaFileContract className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-axa-blue-400">Informations du Souscripteur</h3>
                </div>
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                    {/* Informations Personnelles */}
                    <div className="p-4 bg-gray-100 border-l-4 rounded-lg shadow-md border-info-ocean-200">
                        <h3 className="mb-2 text-lg font-bold text-info-ocean-200">Informations Personnelles</h3>
                        <p><span className="text-info-ocean-200">Nom : </span>{formData.nom}</p>
                        {formData.nomEpouse && (
                            <p><span className="text-info-ocean-200">Nom d'épouse : </span>{formData.nomEpouse}</p>
                        )}
                        <p><span className="text-info-ocean-200">Prénom : </span>{formData.prenom}</p>
                        <p><span className="text-info-ocean-200">Adresse : </span>{formData.adresse}, {formData.codePostal}, {formData.ville}</p>
                        <p><span className="text-info-ocean-200">Numéro passeport / CI : </span>{formData.numCI}</p>
                        <p><span className="text-info-ocean-200">Profession : </span>{formData.profession}</p>
                        <p><span className="text-info-ocean-200">Téléphone : </span>{formData.telephone}</p>
                    </div>

                    {/* Informations du Contrat */}
                    <div className="p-4 bg-gray-100 border-l-4 rounded-lg shadow-md border-success-green">
                        <h3 className="mb-2 text-lg font-bold text-success-green">Informations du Contrat</h3>
                        {discount !== 0 && (
                            <p><span className="text-success-green">Remise groupe : </span> {discount * 100} %</p>
                        )}
                        {formData.remise > 0 && (
                            <p><span className="text-success-green">Remise exceptionnelle : </span> {formData.remise} %</p>
                        )}
                        {formData.remisePartenaire > 0 && (
                            <p><span className="text-success-green">Remise partenaire : </span> {formData.remisePartenaire} %</p>
                        )}
                        <p><span className="text-success-green">Forfait hospitalier :</span> {localOptionFH ? "Oui" : "Non"}</p>
                        <p><span className="text-success-green">Formule de tarif :</span> {formData.optionFamille ? "Solo/Duo/Famille" : "Groupe"}</p>
                        <p><span className="text-success-green">Nombre de voyages : </span>{beneficiaire.length} {beneficiaire.length > 1 ? 'personnes' : 'personne'}</p>
                        <br></br>
                        {nbP70s > 0 && (
                            <p><span className="text-success-green">Nombre de personne(s) 70 ans et + : </span> {nbP70s} </p>
                        )}
                        {nbAs > 0 && (
                            <p><span className="text-success-green">Nombre d'adulte(s) : </span> {nbAs} </p>
                        )}
                        {nbP12s > 0 && (
                            <p><span className="text-success-green">Nombre de personne(s) 12 ans et -18 ans : </span> {nbP12s} </p>
                        )}
                        {nbM12s > 0 && (
                            <p><span className="text-success-green">Nombre d'enfants(s) (11 ans et -) : </span> {nbM12s} </p>
                        )}
                    </div>

                    {/* Informations de Durée */}
                    <div className="p-4 bg-gray-100 border-l-4 rounded-lg shadow-md border-warning-yellow">
                        <h3 className="mb-2 text-lg font-bold text-warning-yellow">Informations de Durée</h3>
                        <p><span className="text-warning-yellow">Destination : </span>{formData.destination}</p>
                        <p><span className="text-warning-yellow">Date de Départ : </span>{formatDate(formData.dateDepart)}</p>
                        <p><span className="text-warning-yellow">Date de Retour : </span>{formatDate(formData.dateRetour)}</p>
                        <p><span className="text-warning-yellow">Durée : </span>{days} {days > 1 ? 'jours' : 'jour'}</p>
                    </div>
                </div>
            </div>

            {/* Informations des Personnes Associées */}
            <div className="p-6 mb-4 shadow-sm">
                <div className="flex items-center mb-4">
                    <div className="p-3 mr-4 rounded-full bg-success-green">
                        <FaUser className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-success-green">Personnes Affectées au Contrat</h3>
                </div>
                {beneficiaire.length > 0 ? (
                    <table className="min-w-full text-center bg-white border border-gray-200 rounded-lg shadow-sm">
                        <thead className="text-white bg-success-green">
                            <tr>
                                <th className="px-4 py-2 border-b">Nom</th>
                                <th className="px-4 py-2 border-b">Prénom</th>
                                <th className="px-4 py-2 border-b">Date de Naissance</th>
                                <th className="px-4 py-2 border-b">Âge</th>
                                <th className="px-4 py-2 border-b">Catégorie</th>
                                {localOptionFH && (
                                    <th className="px-4 py-2 border-b">Eligible forfait hospitalier</th>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {beneficiaire.map((user, index) => {
                                const age = getAge(user.dateNaissance, formData.dateRetour);
                                return (
                                    <tr key={index} className="transition duration-150 border-b hover:bg-success-green hover:bg-opacity-10">
                                        <td className="px-4 py-2">{user.nom}</td>
                                        <td className="px-4 py-2">{user.prenom}</td>
                                        <td className="px-4 py-2">{formatDate(user.dateNaissance)}</td>
                                        <td className="px-4 py-2">{age}</td>
                                        <td className="px-4 py-2">{getCategory(age)}</td>
                                        {localOptionFH && (
                                            <td className="px-4 py-2">{age < 70 ? 'Oui' : 'Non'}</td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-success-green">Aucune personne associée au contrat.</p>
                )}
            </div>

            {/* Calcul du Tarif */}
            <div className="p-6 mb-4 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                    <div className="p-3 mr-4 rounded-full bg-warning-yellow">
                        <FaMoneyBillWave className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-xl font-bold text-warning-yellow">Calcul du Tarif</h3>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div className="p-4 bg-gray-100 rounded-lg shadow-md">
                        <p className="text-gray-800"><strong>Montant HT : </strong>{totalHT.toLocaleString('fr-FR', { minimumFractionDigits: 0 })} XFP</p>
                    </div>
                    <div className="p-4 bg-gray-100 rounded-lg shadow-md">
                        <p className="text-gray-800"><strong>Montant TTC : </strong>{totalTTC.toLocaleString('fr-FR', { minimumFractionDigits: 0 })} XFP</p>
                    </div>
                </div>
            </div>

            {/* Boutons de Navigation */}
            <div className="flex justify-between mt-6 space-x-4">
                <button
                    type="button"
                    onClick={() => handleStepChange(2)}
                    className="px-4 py-2 text-white transition duration-200 rounded bg-axa-blue-400 hover:bg-hover-axa-blue hover:bg-axa-blue-700"
                >
                    Précédent
                </button>
                <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={() => handleValidateContrat()}
                    className={`${isSubmitting ? 'bg-gray-600' : 'bg-success-green hover:bg-green-600'} text-white px-4 py-2 rounded hover:bg-success-green-500 transition duration-200`}
                >
                    Valider et Souscrire
                </button>
            </div>
        </div>
    );

};

export default Step3;
